// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/global.css
// module id = 2691
// module chunks = 0